export interface IFlashObj {
    variavelNo: number;
    valor: string;
}
